import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { orderBy } from "lodash";

import CustomerSelect from "../../common/CustomerSelect";
import DropdownSearch from "../../common/DropdownSearch";
import ContractStatusSelect from "../../common/ContractStatusSelect";

import ReportFilters from "../ReportFiltersComponent";

const RetainerOrClientCareContractsFilters = ({
  filters,
  onChange,
  fetchData,
  handleResetFilters,
  loading,
  onExportClick,
  onPDFExport,
  exportDisabled,
  codes
}) => {
  const generateCodeOptions = (entity, field) => {
    const codeOptions = codes
      ?.filter(
        (code) =>
          code.entity === entity &&
          code.field === field &&
          (code.label === "CLIENTCARE" ||
            code.label === "RETAINER" ||
            code.label === "MANAGED SERVICES")
      )
      ?.map((code) => ({ value: code._id, label: code.label }));

    return orderBy(codeOptions, [(option) => option.label.toLowerCase()]);
  };

  return (
    <ReportFilters
      onFetchClick={fetchData}
      onResetClick={handleResetFilters}
      title="Retainer Or Client Care Contracts"
      loading={loading}
      csvExportAvailable
      pdfExportAvailable
      onCSVExport={onExportClick}
      onPDFExport={onPDFExport}
      exportDisabled={loading || exportDisabled}
    >
      <Row>
        <Col md={3}>
          <CustomerSelect
            placeholder="Select"
            label="Customer"
            isMulti
            onChange={onChange("customer")}
            value={filters.customer || []}
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            rowStyles={{ marginTop: 0 }}
            isMulti
            label="Contract Type"
            placeholder="Select"
            name="contract_type"
            onChange={(name, value) => onChange("contract_type")(value || [])}
            value={filters.contract_type || null}
            data={[...generateCodeOptions("Contract", "type")]}
          />
        </Col>
        <Col md={3}>
          <ContractStatusSelect
            placeholder="Select"
            label="Contract Status"
            value={filters.contract_status || []}
            isMulti
            onChange={onChange("contract_status")}
          />
        </Col>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            End Date
          </label>
          <input
            style={{
              padding: 8,
              border: "1px solid hsl(0,0%,80%)",
              width: "100%",
              borderRadius: 4
            }}
            type="date"
            onChange={(e) => onChange("end_date")(e.target.value)}
            value={filters && filters.end_date}
          />
        </Col>
      </Row>
    </ReportFilters>
  );
};

RetainerOrClientCareContractsFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.object,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  onExportClick: PropTypes.func,
  onPDFExport: PropTypes.func,
  exportDisabled: PropTypes.bool,
  codes: PropTypes.array
};
export default RetainerOrClientCareContractsFilters;
